var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close-page",attrs:{"type":"button","aria-label":_vm.t('button-close'),"title":_vm.t('button-close')},on:{"click":_vm.close}},[_vm._v("✕")])}
var staticRenderFns = []

export { render, staticRenderFns }